import { Suspense, type FunctionComponent } from 'react';

// oxlint-disable-next-line no-restricted-imports
import type { LogoProps } from '@atlaskit/logo';
import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyRovoIcon: FunctionComponent<
  LogoProps & { shouldUseHexLogo?: boolean }
> = (props) => {
  const RovoIcon = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "atlaskit-logo-rovo" */ '@atlaskit/logo/rovo-hex/icon'
      ),
    { namedImport: 'RovoHexIcon' },
  );

  return (
    <ErrorBoundary tags={{ ownershipArea: 'trello-web-eng' }}>
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <RovoIcon {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
